import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { sectionTitle, sectionTitleBar } from '../workflow/constants';

/**
 * Hub 入口卡片與區段標題——Workflow hub 與 Management hub 共用同一套觀感，
 * 要改卡片長相只改這裡。
 *
 * 版型：左上 icon、右上徽章與 chevron、下方名稱與一行說明。
 * `iconClass` 是分區自己的 icon 底色（Management 一區一色）；不給就是藍色。
 * `badge` 放在 chevron 左邊（待審筆數、Not live 之類）。
 * `muted` 整張打灰但仍可點進去。
 */
export const HubSectionHeader = ({ title, description }) => (
  <>
    <h2 className={sectionTitle}>
      <span className={sectionTitleBar} aria-hidden="true" />
      {title}
    </h2>
    {description && <p className="text-xs text-slate-500 mt-0.5 mb-3">{description}</p>}
  </>
);

export const HubCardGrid = ({ children }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">{children}</div>
);

const HubCard = ({ to, icon: Icon, name, description, iconClass = 'bg-blue-50 text-blue-600', badge = null, muted = false }) => (
  <Link
    to={to}
    className={`rounded-lg border p-5 transition-all group ${
      muted
        ? 'bg-slate-100 border-slate-200 hover:border-slate-300'
        : 'bg-white border-slate-200 hover:border-blue-300 hover:shadow-sm'
    }`}
  >
    <div className="flex items-start justify-between">
      <div className={`p-2 rounded-lg ${muted ? 'bg-slate-200 text-slate-400' : iconClass}`}>
        <Icon className="w-5 h-5" />
      </div>
      <div className="flex items-center gap-2 mt-1">
        {badge}
        <ChevronRight className={`w-4 h-4 text-slate-300 ${muted ? '' : 'group-hover:text-blue-500'}`} />
      </div>
    </div>
    <h3 className={`mt-3 text-base font-semibold ${muted ? 'text-slate-500' : 'text-slate-900'}`}>{name}</h3>
    <p className={`mt-1 text-xs leading-relaxed ${muted ? 'text-slate-400' : 'text-slate-500'}`}>{description}</p>
  </Link>
);

export default HubCard;
